import IdvDocumentSubmit from './idv-document-submit';

export default IdvDocumentSubmit;
